import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

function resetScroll() {
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

/**
 * Сбрасывает прокрутку окна при смене маршрута (pathname + search).
 * Дублирует сброс на documentElement/body для WebView (Telegram) и старых WebKit.
 */
export function ScrollToTop() {
  const { pathname, search } = useLocation();
  const routeKey = `${pathname}${search}`;

  // До отрисовки новой страницы — убирает визуальный «миг» на длинных переходах
  useLayoutEffect(() => {
    resetScroll();
  }, [routeKey]);

  // После paint — на случай отложенного layout / подгрузки контента
  useEffect(() => {
    resetScroll();
    const id = requestAnimationFrame(() => {
      resetScroll();
    });
    return () => cancelAnimationFrame(id);
  }, [routeKey]);

  return null;
}
